import React from 'react';
export default function Contact(){
  return (
    <section className="section contact-page">
      <h2>Contact</h2>
      <div className="contact-grid">
        <div>
          <p><strong>Main:</strong> (681) 292-3359</p>
          <p><strong>Detail:</strong> (681) 549-8603</p>
          <p><strong>Address:</strong> 1038 Quarrier St, Charleston, WV 25301</p>
          <p><strong>Hours:</strong> Mon–Sat 8am–7pm</p>
        </div>
        <form name="contact" method="POST" data-netlify="true" className="form">
          <input name="name" placeholder="Your name" required />
          <input name="email" placeholder="Email" required />
          <textarea name="message" placeholder="Message" required />
          <button className="btn primary" type="submit">Send</button>
        </form>
      </div>
    </section>
  );
}